import { useModalStore } from '@/stores/modal.store'
import { AxiosError } from 'axios'

export const handleError = (e: unknown): number => {
  const { showModal } = useModalStore()

  let message = 'Ada masalah server, silakan hubungi tim terkait'
  let status = 500

  if (e instanceof AxiosError) {
    status = e.response?.status ?? 500
    message = e.response?.data.message

    if (status === 404) {
      message = 'Data tidak ditemukan'
    }
  }

  showModal('error', message, status?.toString())
  return status
}
